module.exports = __webpack_public_path__ + "static/media/2_en.4ee80c54.png";